import { type Option, type OptionValue } from "@/components/types/option";

import { OptionFieldsConfig } from "../../SelectBase";

import { isSelected } from "./isSelected";

function sortOptionsByChecked<TValue extends Option>(
  options: Array<TValue>,
  selected: OptionValue<TValue>[] | undefined,
  fieldConfig: OptionFieldsConfig<TValue>,
): Array<TValue> {
  if (!selected) {
    return options;
  }
  return options.sort((a, b) => {
    const isAChecked = isSelected(a, selected, fieldConfig);
    const isBChecked = isSelected(b, selected, fieldConfig);

    if (isAChecked === isBChecked) {
      return 0;
    } else if (isAChecked) {
      return -1;
    } else if (isBChecked) {
      return 1;
    }
    return 0;
  });
}

export { sortOptionsByChecked };
